import { Vue, Component, Prop, Emit } from "vue-property-decorator"

@Component
class Modal extends Vue {
  @Prop({ default: 300 })
  width
  @Prop()
  borderLeft
  @Prop({ default: "" })
  containerClass
  @Prop({ default: false })
  noPadding
  @Prop({ default: false })
  noOverflowY
  @Prop({ default: false })
  noMargin
  @Emit()
  Close() {}

  render() {
    const containerStyle = {
      "max-width": this.width + "px",
    }
    if (this.borderLeft) {
      containerStyle["border-left"] = this.borderLeft
    }
    if (this.noPadding) {
      containerStyle["padding"] = 0
    }
    return (
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper px-4">
            <div
              style={containerStyle}
              class={"modal-container w-full mx-auto " + this.containerClass}
            >
              {this.$slots["header"]}

              <div
                class={
                  "modal-body " +
                  (!this.noOverflowY ? " overflow-y-auto" : "") +
                  (!this.noMargin ? " my-2" : " m-0")
                }
                id="modal-body"
                style={this.noPaddingStyle}
              >
                {this.$slots["body"]}
              </div>

              {this.$slots.hasOwnProperty("footer") ? (
                this.$slots["footer"]
              ) : (
                <div class="modal-footer">
                  <button
                    class="btn btn-outline-secondary"
                    onClick={this.Close}
                  >
                    Fechar
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </transition>
    )
  }
}

export default Modal

// VUE JSX HOT LOADER //
if (module.hot) require("/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: __webpack_exports__, module: module, hotId: "_vue_jsx_hot-b025cb1a/Modal.jsx" });